// extracted by mini-css-extract-plugin
export default {"container":"ModalInsert_container__yt9dW","mydivheader":"ModalInsert_mydivheader__pTgjG","mydiv":"ModalInsert_mydiv__Sz9zx","main":"ModalInsert_main__ymEn4"};